<div class="btn-close-container" mat-dialog-actions align="end">
    <button mat-mini-fab matTooltip="Seite schließen" mat-dialog-close color="primary" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>
<app-user-profile-public [username]="data.userId" [index]="data.index"></app-user-profile-public>
